import { z } from 'zod';

export const ssmParameterSecretSchema = z.object({
  type: z.literal('ssm-parameter'),
  parameter: z.string(),
});

export const environmentVariableSecretSchema = z.object({
  type: z.literal('environment-variable'),
  variable: z.string(),
});

export const secretFormSchema = z.discriminatedUnion('type', [
  ssmParameterSecretSchema,
  environmentVariableSecretSchema,
]);
